import {AppliedFilterSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';
import {GetNavigationHeaderResponse_CategoryItem} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/category_page/v1/navigation/service.types';
import {useTrackOriginClick} from '@aboutyou/tracking';
import {CategoryList} from '@aboutyou/ui-components';
import React from 'react';
import {SearchFilter} from '../Filters/SearchFilter/SearchFilter';
import {CategorySliderWrapper} from './CategorySliderLoading';
import {useNormalizedCategories} from './helpers';

interface CategorySliderProps {
  activeCategoryId?: number;
  appliedFilters?: AppliedFilterSection;
  categories?: Array<ExtendedCategoryItem>;
  appliedFiltersCount?: number;
  useButtonLink?: boolean;
}

export interface ExtendedCategoryItem
  extends GetNavigationHeaderResponse_CategoryItem {
  targetPath?: string;
}

export const CategorySlider: React.FC<CategorySliderProps> = React.memo(
  function CategorySlider({
    activeCategoryId,
    categories,
    appliedFilters,
    useButtonLink,
  }) {
    const normalizedCategories = useNormalizedCategories(
      activeCategoryId,
      categories,
    );

    const trackOriginClick = useTrackOriginClick()('category_quick_filter');

    return (
      <>
        <CategorySliderWrapper data-testid="categorySlider">
          <CategoryList
            categories={normalizedCategories}
            onClick={trackOriginClick}
            useButtonLink={useButtonLink}
          />
        </CategorySliderWrapper>
        {appliedFilters && <SearchFilter filters={appliedFilters.values} />}
      </>
    );
  },
);
